(function () {
  function initFaq(root) {
    if (!root || root.dataset.auInit === '1') return;
    root.dataset.auInit = '1';
    var items = root.querySelectorAll('.au-faq__item');
    items.forEach(function (item) {
      var btn = item.querySelector('.au-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (i) {
          i.classList.remove('is-open');
          var b = i.querySelector('.au-faq__q');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function bootstrap() {
    document.querySelectorAll('[data-au-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-au-faq]');
    if (root) initFaq(root);
  });
})();
